import { reducer as formReducer } from "redux-form";
import mainUserReducer from "./mainUserReducer";
import configurationReducer from "./configurationReducer";
import clientsReducer from "./clientsReducer";
import globalAlertReducer from "./globalAlertReducer";
import projectsReducer from "./projectsReducer";
import supportReducer from "./supportReducer";

import amenitiesReducer from "./amenitiesReducer";
import servicesReducer from "./servicesReducer";

import chatReducer from "./chatReducer";

import onnaDevicesReducer from "./onnaDevicesReducer";
import apartmentsReducer from "./apartmentsReducer";
import knxAddressReducer from "./knxAddressReducer";
import notificationsReducer from "./notificationsReducer";
import settingsReducer from "./settingsReducer";
import macroReducer from "./macroReducer";
import scheduleReducer from "./scheduleReducer";
import systemStateReducer from "./systemStateReducer";
import trendsReducer from "./trendsReducer";
import cloudApisReducer from "./cloudApisReducer";
import occupancyReducer from "./occupancyReducer";
import thermostatIPReducer from "./thermostatIPReducer";
import bacnetAddressReducer from "./bacnetAddressReducer";
import clientReservationsReducer from "./clientReservationsReducer";
import projectManagersReducer from "./projectManagersReducer";

const reducers = {
  mainUserReducer,
  bacnetAddresses: bacnetAddressReducer,
  clientsReducer,
  clientReservationsReducer,
  supportReducer,
  globalAlertReducer,
  projectsReducer,
  amenitiesReducer,
  servicesReducer,
  chatReducer,
  configurationReducer,
  settingsReducer,
  macroReducer,
  scheduleReducer,
  systemStateReducer,
  onnaDevicesReducer,
  apartmentsReducer,
  knxAddressReducer,
  notificationsReducer,
  trendsReducer,
  cloudApisReducer,
  occupancyReducer,
  thermostatIPReducer,
  projectManagers: projectManagersReducer,
  form: formReducer,
};

export default reducers;
